<template>
  <Dialog :title="title" :content="body" :cancel="cancel" :confirm="confirm" data-testid="confirm-restore-dialog" @close="(value) => $emit('close', value)" />
</template>

<script>
import Dialog from "~/components/dialogs/Dialog";

export default {
  components: { Dialog },
  props: {
    title: { type: String, default: "Gendan" },
    body: { type: String, required: true },
    confirm: { type: String, default: "Gendan" },
    cancel: { type: String, default: "Annuller" },
  },

  emits: ["close"],
};
</script>
